<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input size="small" placeholder="请输入姓名/手机号搜索" v-model="queryParam"
                              style="width: 240px" suffix-icon="el-icon-search">
                    </el-input>
                    <el-button type="primary" @click="searchDoctor" style="width: 96px">查询</el-button>
                </div>
                <div>
                    <el-button type="primary" @click="addDoctor" style="width: 96px">新增医生</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="realName" label="医生姓名"></el-table-column>
                    <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
                    <el-table-column prop="technicalPost" label="职称"></el-table-column>
                    <el-table-column prop="administrativeOffice" label="科室"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editDoctor(scope.row)">修改</el-button>
                            <el-button type="text" class="delete-button" @click="deleteDoctor(scope.row)">冻结</el-button>
                            <el-button type="text"  @click="openHis(scope.row)">开通HIS</el-button>
                            <span v-if="scope.row.isOnline === '1'">
                                <el-button type="text" @click="cancleOffLine(scope.row)">取消线下支付</el-button>
                            </span>                        
                            <span v-else>
                                <el-button type="text"  @click="openOffLine(scope.row)">开通线下支付</el-button>
                            </span>
                                                       
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增医生" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="doctorAdd" :rules="rules" ref="add" size="small" label-width="90px">
                <el-form-item label="医生名称:" prop="realName">
                    <el-input v-model="doctorAdd.realName" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="手机号:" prop="phoneNumber">
                    <el-input v-model="doctorAdd.phoneNumber" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="职称:" prop="technicalPost">
                    <el-select v-model="doctorAdd.technicalPost" placeholder="选择职称"
                               style="width: 320px;">
                        <el-option v-for="item in technicalPost" :key="item.id"
                                   :label="item.title" :value="item.title"></el-option>
                    </el-select>
                </el-form-item>
            
                <el-form-item label="科室:" prop="administrativeOffice">
                    <el-select v-model="doctorAdd.administrativeOffice" placeholder="选择科室"
                                style="width: 320px;">
                        <el-option v-for="item in administrativeOffice" :key="item.id"
                                    :label="item.title" :value="item.title"></el-option>
                    </el-select>
                </el-form-item>
               
                <el-form-item label="擅长:" prop="specialize">
                    <el-input v-model="doctorAdd.specialize" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="备注:" prop="remitRemake">
                    <el-input v-model="doctorAdd.remitRemake" style="width: 320px"></el-input>
                </el-form-item>

<!--                <el-form-item label="证件:" prop="realNameImage">-->
<!--                    <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">-->
<!--                        <i class="el-icon-plus push"></i>-->
<!--                        <el-image v-if="doctorAdd.realNameImage"  class="course-img" :src="formatImage(doctorAdd.realNameImage)"></el-image>-->
<!--                        <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>-->
<!--                    </div>-->
<!--                </el-form-item>-->
               
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑医生" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="doctorEdit" :rules="rules" ref="edit" size="small" label-width="90px">
                <el-form-item label="医生名称:" prop="realName">
                    <el-input v-model="doctorEdit.realName" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="手机号:" prop="phoneNumber">
                    <el-input v-model="doctorEdit.phoneNumber" style="width: 320px"></el-input>
                </el-form-item>

<!--                <el-form-item label="职称:" prop="technicalPost">-->
<!--                    <el-select v-model="doctorEdit.technicalPost" placeholder="选择职称"-->
<!--                               style="width: 320px;">-->
<!--                        <el-option v-for="item in technicalPost" :key="item.id"-->
<!--                                   :label="item.title" :value="item.title"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->

                <el-form-item label="科室:" prop="administrativeOffice">
                    <el-select v-model="doctorEdit.administrativeOffice" placeholder="选择科室"
                                style="width: 320px;">
                        <el-option v-for="item in administrativeOffice" :key="item.id"
                                    :label="item.title" :value="item.title"></el-option>
                    </el-select>
                </el-form-item>
               
                <el-form-item label="擅长:" prop="specialize">
                    <el-input v-model="doctorEdit.specialize" style="width: 320px"></el-input>
                </el-form-item>

<!--                <el-form-item label="备注:" prop="remitRemake">-->
<!--                    <el-input v-model="doctorEdit.remitRemake" style="width: 320px"></el-input>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="证件:" prop="realNameImage">-->
<!--                    <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">-->
<!--                        <i class="el-icon-plus push"></i>-->
<!--                        <el-image v-if="doctorEdit.realNameImage"  class="course-img" :src="formatImage(doctorEdit.realNameImage)"></el-image>-->
<!--                        <input type="file" class="upload-input" @change="editImg" accept="image/*" ref="editPicture"/>-->
<!--                    </div>-->
<!--                </el-form-item>-->


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
      
        <el-dialog title="开通HIS" :visible.sync="dialogHisUserVisible" width="560px" :close-on-click-modal="false">
        <el-form :model="hisUserEdit"  label-width="100px" size="small">
            <el-form-item label="关联诊所:" prop="hospitalNo">

                <el-select v-model="hisUserEdit.hospitalNo" placeholder="选择诊所" style="width: 140px;">
                    <el-option value="" label="无"></el-option>
                    <el-option v-for="item in hospital" :key="item.hospitalNo"
                            :label="item.hospitalName" :value="item.hospitalNo">
                    </el-option>
                </el-select>
            </el-form-item>
           
        </el-form>
        <div slot="footer" class="dialog-footer charge">
            <el-button @click="dialogHisUserVisible = false" style="width: 76px">取消</el-button>
            <el-button type="primary" @click="confirmHisUser" style="width: 76px">确定</el-button>
        </div>
    </el-dialog>   

    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                queryParam: '',
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                administrativeOffice: [],
                technicalPost: [],
                userList: [],
                dialogAddVisible: false,
                doctorAdd: {
                    realName: '',
                    phoneNumber:'',
                    administrativeOffice: '',
                    technicalPost:'',
                    specialize: '',
                    remitRemake:'',
                    //realNameImage:''
                },
                rules: {
                    realName: [{required: true, message: '请输入医生姓名', trigger: 'blur'}],
                    phoneNumber: [{required: true, message: '请输入手机号', trigger: 'blur'}],
                    
                },                
                items: [],
                dialogEditVisible: false,
                doctorEdit: {
                    realName: '',
                    phoneNumber:'',
                    administrativeOffice: '',
                    //technicalPost:'',
                    specialize: '',
                    //remitRemake:'',
                },
                dialogHisUserVisible:false,
                hospital:[],
                hisUserEdit:{
                    id:'',
                    hospitalNo:''
                }
            };
        },
        methods: {
            // 获取医生列表
            getData() {
                this.loading = true
                let params = {
                    queryParam: this.queryParam,                   
                }
                this.axios.post('api-b/10041/100158/' + this.pageNum + '/' +this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
             searchDoctor(){
                this.getData();
            },
            // 获取科室
            getAdministrativeOffice() {
                this.axios.get('api-b/10046/100178',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.administrativeOffice = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            //获取职称
            gettechnicalPost(){
                this.axios.get('api-b/10046/100179/1',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000){
                        this.technicalPost = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                    }

                )
            },
            // 取消新增
            cancelAdd() {
              this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 新增医生弹窗按钮
            addDoctor() {
                this.getAdministrativeOffice()
                this.gettechnicalPost()
                this.dialogAddVisible = true
            },
           
            // 确认新增医生
            confirmAdd() {
                this.$refs.add.validate(valid => {
                                          
                    let params = {
                        realName: this.doctorAdd.realName,
                        phoneNumber: this.doctorAdd.phoneNumber,
                        administrativeOffice:this.doctorAdd.administrativeOffice,
                        technicalPost:this.doctorAdd.technicalPost,
                        specialize: this.doctorAdd.specialize,
                        remitRemake:this.doctorAdd.remitRemake,
                        //realNameImage:this.doctorAdd.realNameImage,
                    }
                    this.axios.post('api-b/10041/100139/',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.dialogAddVisible = false
                            this.$message.success(res.data.message)
                            this.getData()
                        
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                    
                })
            },
            //新增证件图片
            addImg(){
                let inputDOM = this.$refs.picture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'realNameImage')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.doctorAdd.realNameImage = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            //修改证件图片
            editImg(){
                let inputDOM = this.$refs.editPicture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'realNameImage')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.doctorEdit.realNameImage = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            uploadImg(data) {
                return new Promise(resolve => {
                    this.axios.post('/api-f/10027/100065',data,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                    }).then(res => {
                        resolve(res)
                    })
                })
            },
            formatImage(imageurl) {
                let baseurl = "http://test.zgtyyy.com/chinesemedicine";
                return imageurl ? baseurl + imageurl : baseurl + "/src/images/default.png"

            },
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 编辑医生弹窗按钮
            editDoctor(data) {
                
                 this.axios.get('/api-b/10041/100161/' + data.id,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    
                    if(res.data.code=== 10000) {
                        if (res.data.data !== null) {
                            this.dialogEditVisible = true
                            this.doctorEdit = res.data.data
                            this.getAdministrativeOffice()
                            this.gettechnicalPost()
                        } else {
                            this.$message.info(res.data.message)
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        let list = []
                         for (let i=0; i<this.hospitalEdit.pharmacy.length; i++) {
                             let pharmacy = {
                                 pharmacyId: this.hospitalEdit.pharmacy[i].pharmacyId
                             }
                            list.push(pharmacy)
                         }
                        let params = {
                             hospitalId: this.hospitalEdit.hospitalId,
                             hospitalName: this.hospitalEdit.hospitalName,
                             province: this.hospitalEdit.province,
                             city: this.hospitalEdit.city,
                             district: this.hospitalEdit.district,
                             address: this.hospitalEdit.address,
                             userId: this.hospitalEdit.userId,
                             hospitalPrincipalPhone: this.hospitalEdit.hospitalPrincipalPhone,
                             hospitalPrincipalName: this.hospitalEdit.hospitalPrincipalName,
                             list: list,
                           /* realName: this.doctorEdit.realName,
                            phoneNumber: this.doctorEdit.phoneNumber,
                            administrativeOffice:this.doctorEdit.administrativeOffice,
                            technicalPost:this.doctorEdit.technicalPost,
                            specialize: this.doctorEdit.specialize,
                            remitRemake:this.doctorEdit.remitRemake,
                            realNameImage:this.doctorEdit.realNameImage,*/

                        }
                        this.axios.post('/api-b/10018/100096',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogEditVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.edit.resetFields()
                                    // this.hospitalEdit.pharmacy = []
                                    // this.overPharmacy = []
                                    // if(this.$refs.addPharmacy){
                                    //     this.$refs.addPharmacy.$children["0"]._data.query = '';
                                    //     // 清空右边搜索
                                    //     this.$refs.addPharmacy.$children["3"]._data.query = '';
                                    // }
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })

                    } else{
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            deleteDoctor(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要冻结该医生吗？'),
                        ]),
                        h('div', null, [
                            h('span', { class:'message-box-main'}, '冻结后，该医生将无法正常登陆。'),
                        ]),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append('id',data.id)
                    this.axios.post('/api-b/10037/100154',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })

            },
            openHis(data){
                this.hisUserEdit.id = data.id
                let params = {
                    auditStatus:'CHECK_SUCC',                   
                }
                this.axios.post('/api-b/10018/100095/1/999',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.dialogHisUserVisible = true
                            this.hospital = res.data.data.list
                        } else {
                            this.$message.info('暂无数据')
                            this.hospital = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.hospital = []
                    }
                })
            },
            confirmHisUser(){
               let params = {
                    id: this.hisUserEdit.id,
                    hospital: this.hisUserEdit.hospitalNo                    
                }
                this.axios.post('/api-b/10041/100196',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogHisUserVisible = false
                        this.$message.success(res.data.message)
                        this.getData();
                    } else {
                        this.$message.error(res.data.message)                        
                    }
                })
            },
            openOffLine(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要开通该医生的线下支付功能吗？'),
                        ]),
                       
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                   
                    let params = {
                        id:data.id,
                        isOnline:1                       
                    }
                    this.axios.post('/api-b/10041/100197',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })

            },
        cancleOffLine(data){
            const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要取消该医生的线下支付功能吗？'),
                        ]),
                       
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                   
                    let params = {
                        id:data.id,
                        isOnline:0                       
                    }
                    this.axios.post('/api-b/10041/100197',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })
        }
        },
        watch: {
            hospitalName: {
                handler() {
                    this.pageNum = 1
                    this.getData()
                }
            }
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
    .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>